import React, { useEffect, useState } from 'react';
import {
  Container,
  Divider,
  FormControl,
  MenuItem,
  Paper,
  Select,
} from '@mui/material';
import {
  fetchAccounts,
  fetchKioskBinsUtilizationReport,
} from '../helpers/api.helpers';
import { formatBinsReportToGraphData } from '../helpers/data.helpers';
import BinUtilizationChart from './BinUtilizationChart';
import moment from 'moment';
import { getTimeZone } from '../../../../utils/datetime.utils';
import { useTranslation } from 'react-i18next';
//import ends

const timeZone = getTimeZone();

/**
 *
 * Actual Component
 */

const GraphView = ({ setLoader }) => {
  const { t } = useTranslation();
  const [perBoxBinsUtilization, setPerBoxBinsUtilization] = useState([]);
  // const [totalStoreOrders, setTotalStoreOrders] = useState([]);
  const [selectedRange, setSelectedRange] = useState(rangeSelector(t)[1].value);
  const [selectedAccount, setSelectedAccount] = useState();
  const [accounts, setAccounts] = useState([]);

  useEffect(() => {
    (async () => {
      setLoader(true);
      const accounts = await fetchAccounts();
      setAccounts(accounts);
      setSelectedAccount(selectDefaultAccount(accounts));
      setLoader(false);
    })();
  }, []);

  useEffect(() => {
    if (!selectedAccount) return;
    (async () => {
      setLoader(true);
      // get data from apis on page load
      const binsData = await fetchKioskBinsUtilizationReport({
        sinceDays: selectedRange,
        timeZone,
        accountId: selectedAccount,
      });
      // const ordersData = await fetchKioskOrdersUtilizationReport({
      //   sinceDays: selectedRange,
      //   timeZone,
      //   accountId: selectedAccount,
      // });
      // manipulate data so it can fit in graphs
      setPerBoxBinsUtilization(formatBinsReportToGraphData(binsData));
      // setTotalStoreOrders(
      //   formatOrdersReportToGraphData(ordersData, selectedRange)
      // );
      setLoader(false);
    })();
  }, [selectedRange, selectedAccount]);

  if (!selectedAccount) return null;

  return (
    <React.Fragment>
      <Divider sx={{ mt: '10px', height: '5px' }} />

      {/* input container  */}
      <Container
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          my: '10px',
          gap: '20px',
        }}
      >
        <b>{t('Accounts.Account')}</b>
        <FormControl variant="standard">
          <Select
            id="box-utilization-accounts"
            value={selectedAccount}
            fullWidth={true}
            onChange={(e) => setSelectedAccount(e.target.value)}
          >
            {accounts.map((range, i) => (
              <MenuItem value={range.id} key={i}>
                {range.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <b>{t('Report.KioskUtil.Graph.UtilizationByPeriod')}</b>
        <FormControl variant="standard">
          <Select
            id="box-utilization-chart-range"
            value={selectedRange}
            onChange={(e) => setSelectedRange(e.target.value)}
          >
            {rangeSelector(t).map((range, i) => (
              <MenuItem value={range.value} key={i}>
                {range.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Container>

      {/* chart  */}
      <Paper>
        <Container sx={{ height: '21px' }}></Container>
        <BinUtilizationChart
          data={perBoxBinsUtilization}
          selectedRange={selectedRange}
        />
        {/* <Container sx={{ height: '21px' }}></Container>
        <BoxOrdersChart data={totalStoreOrders} selectedRange={selectedRange} /> */}
      </Paper>
    </React.Fragment>
  );
};
// end of component

/**
 *
 *
 *
 *  Helpers
 */

const getDayDiffByRange = ({ amount, unit }) => {
  return moment()
    .tz(timeZone)
    .diff(
      moment()
        .tz(timeZone)
        .subtract(amount, unit),
      'days'
    );
};
const rangeSelector = (t) => [
  {
    value: getDayDiffByRange({ amount: 7, unit: 'days' }),
    label: t('Report.KioskUtil.Graph.LastSevenDays'),
  },
  {
    value: getDayDiffByRange({ amount: 1, unit: 'month' }),
    label: t('Report.KioskUtil.Graph.LastThirtyDays'),
  },
  {
    value: getDayDiffByRange({ amount: 3, unit: 'months' }),
    label: t('Report.KioskUtil.Graph.LastThreeMonths'),
  },
  {
    value: getDayDiffByRange({ amount: 6, unit: 'months' }),
    label: t('Report.KioskUtil.Graph.LastSixMonths'),
  },
  {
    value: getDayDiffByRange({ amount: 1, unit: 'year' }),
    label: t('Report.KioskUtil.Graph.LastTwelveMonths'),
  },
];

const selectDefaultAccount = (accounts) => {
  if (!accounts || !accounts.length) return null;

  const parentAccountId = sessionStorage.getItem('parentAccountId');
  if (accounts.some((acc) => acc.id === parentAccountId))
    return parentAccountId;

  const selectedLocation = localStorage.getItem('selectedLocation');
  if (accounts.some((acc) => acc.id === selectedLocation))
    return selectedLocation;

  return accounts[0].id;
};
export default GraphView;



// WEBPACK FOOTER //
// ./src/components/reports/kiosk-box-utilization/graph-view/index.jsx